module.exports = __webpack_public_path__ + "img/painPerceptionScale_6_w.dec1428b.png";